export default __webpack_public_path__ + "static/media/textcomponent.a5fad0c9.svg";